import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import Home from './views/Home.vue'

Vue.config.productionTip = false

console.log(Home)

new Vue({
  router,
  store,
  render: h => h(App),
  components: {
    Home: Home
  }
}).$mount('#app')
